import * as React from "react";
import { css } from "@emotion/react";
import Link from "next/link";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";

interface RegionListItem {
  text: string;
  url?: string;
}

export interface IProps {
  listItems: RegionListItem[];
}

export const RegionList: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  return (
    <ul css={blockStyle}>
      {props.listItems.map((link, index) => (
        <li key={index} css={listStyle}>
          {link.url ? (
            <Link href={link.url} passHref>
              <a css={linkStyle}>{link.text}</a>
            </Link>
          ) : (
            <span css={textStyle}>{link.text}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

const blockStyle = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${space.atom2_5x} ${space.atom3x};
  padding: 0;
  margin: 0;
  list-style: none;
  ${moreThanBreakpoint("tablet")} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  ${moreThanBreakpoint("desktop")} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

const listStyle = css`
  margin: 0;
  padding: 0;
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
  color: ${textColor.secondaryDarkColor};
`;

const linkStyle = css`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
    text-underline-offset: 4px;
  }
`;

const textStyle = css`
  color: inherit;
`;
